<template>
    <div class="navi">
        <template>
            <router-link :to="{name:'COSettingHospitalInternal', params:{
               careOrchestratorInstitutionId: this.careOrchestratorInstitutionId,
               certificationFlag: this.certificationFlag,
               searchConditions: this.searchConditions 
            }}">
                <div :class='getClass("COSettingHospitalInternal")'><b-icon icon="hospital-building"/>施設管理</div>
            </router-link>
            <router-link :to="{name:'COSettingUserInternal', params:{
               careOrchestratorInstitutionId: this.careOrchestratorInstitutionId,
               certificationFlag: this.certificationFlag,
               searchConditions: this.searchConditions 
            }}">
                <div :class='getClass("COSettingUserInternal")'><b-icon icon="account-multiple"/>ユーザー管理</div>
            </router-link>
            <router-link v-if="certificationFlag" :to="{name:'COSettingClientCertificateInternal', params:{
               careOrchestratorInstitutionId: this.careOrchestratorInstitutionId,
               certificationFlag: this.certificationFlag,
               searchConditions: this.searchConditions 
            }}">
                <div style="width:200px" :class='getClass("COSettingClientCertificateInternal")'><b-icon icon="certificate "/>クライアント証明書</div>
            </router-link>
        </template>
    </div>
</template>

<script>
export default {
  name: "SettingNaviBar",
  props: ["pageid"],
  methods: {
    getClass: function(tabkind) {
      var ret = "tabLabel ";
      if(tabkind == this.pageid){
        ret += "active";
      } else {
        ret += "deactive";
      }
      return ret;
    },
  },
  data() {
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    let certificationFlag = this.$route.params["certificationFlag"];
    let searchConditions = this.$route.params["searchConditions"];
    return {
      careOrchestratorInstitutionId: careOrchestratorInstitutionId,
      certificationFlag: certificationFlag,
      searchConditions: searchConditions,
    };
  },
  filters: {},
  components: {},
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.navi {
    height: 20px;
    margin-top:-20px;
}
.tabLabel {
    float:left;
    text-align: center; 
    border-radius: 10px 10px 0px 0px;
    border-width:1px;
	border-top-style: solid;
	border-right-style: solid;
	border-left-style: solid;
    width: 150px;
    height: 30px;
}
.tabLabel.active {
    color: white;
	border-color: #000894;
    background-color: #000894;
}
.tabLabel.deactive {
	border-color: #f7f7f7;
    background-color: #e4e4e4;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/careorchestrator/SettingNaviBar.vue